<script>
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import DialogContentInput from "../../../../components/dialog/DialogContentInput.svelte";
  import HelpTooltip from "../../../../components/tooltip/HelpTooltip.svelte";
  import { createForm } from "felte"
  import { validator } from "@felte/validator-zod";
  import { getNotificationsContext } from "svelte-notifications";
  import { z } from "zod";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import { translate } from "../../../../i18n/i18next.js";

  const {addNotification} = getNotificationsContext()

  export let onClose

  const schema = z.object({
    magicnumber: z.string()
      .min(1, translate("frontend:components.applyMagicnumberDialog.errors.inputMagicnumber"))
      .regex(/^[A-Z0-9\-]+$/, translate("frontend:components.applyMagicnumberDialog.errors.malformedMagicnumber")),
  })

  async function handleSubmit(data) {
    const response = await fetch("/api/license/e-protector/magicnumber", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      }
    })
    const responseData = await response.json().catch(() => null)
    if (response.ok) {
      addNotification({
        text: translate("frontend:components.applyMagicnumberDialog.messages.applied"),
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });
      onClose()
    } else {
      addNotification({
        text: translate("frontend:components.applyMagicnumberDialog.messages.applicationFailed", null, {error: responseData?.type}),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
    }
  }

  const {form, createSubmitHandler, errors} = createForm({
    onSubmit: handleSubmit,
    extend: validator({schema})
  })
  const submitHandler = createSubmitHandler()
</script>

<DialogTitle title={translate("frontend:components.applyMagicnumberDialog.title")}></DialogTitle>
<DialogSplitter/>
<DialogContent>
  <form use:form>
    <DialogContentInput name="magicnumber" error={$errors.magicnumber}>
        <span slot="label">
          {translate("generic.license.hasp.magicnumber")}
        </span>
      <HelpTooltip title={translate("generic.license.hasp.magicnumber")}>
        {translate("frontend:components.applyMagicnumberDialog.magicnumber.tooltip")}
      </HelpTooltip>
    </DialogContentInput>
  </form>
</DialogContent>
<DialogBottomControls>
  <DialogBottomControlButton type="primary" onClick={submitHandler}>
    {translate("generic.apply")}
  </DialogBottomControlButton>
  <DialogBottomControlButton type="secondary" onClick={onClose}>
    {translate("generic.cancel")}
  </DialogBottomControlButton>
</DialogBottomControls>
